// ABS.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function ABS() {
    return (
        <PageLayout title="ABS" subtitle="ABS overview">
            <div className="container flex col box-container">
                {/* <div className="box">ABS</div> */}
            </div>
        </PageLayout>   
    );
}

export default ABS;
